<div id="card-status-body">
  <div id="card-container">
    <app-card-status-success [message]="successMessage" *ngIf="success; else elseBlock"></app-card-status-success>
    <ng-template #elseBlock>
      <div id="card-status-index-container">
        <h2 class="mt-10">Card status tracking</h2>
        <div class="mb-16">
          Waiting for your license or ID card to be mailed? Most cards take up to 60 days to arrive.
          Select your card below to find out if your card is on its way, or still being processed.
        </div>
        <ng-container *ngIf="areCardsLoaded$ | async; else loading">
          <button mat-stroked-button type="submit" id="card-status-submit-button"
                  *ngFor="let cardType of userCards"
                  (click)="checkCardStatus(cardType.value)">
            <span class="btn-wrapper">
                <span>{{cardType.viewValue}}</span>
                <mat-icon svgIcon="encircled-arrow"></mat-icon>
            </span>
          </button>
        </ng-container>
        <ng-template #loading>
          <mat-spinner [mode]="'indeterminate'"
                       [diameter]="40"
                       [color]="'accent'"
                       class="mt-30 mb-8"></mat-spinner>
        </ng-template>
      </div>
    </ng-template>
  </div>
</div>
